import React from "react";
import Logo_Constructora from "../../assets/logo-constructora-white.svg";
import Logo_Proyecto from "../../assets/logo_proyecto-white.svg";

// const Floors = require("../../data/floor.data"); -> allFloorsUpdated
// const PropertyType = require("../../data/property.type.data"); -> allPropertyTypeUpdated

interface Props {
  showIntro: boolean,
  audioMute: boolean;
  propertyType: any;
  property: any;
  floor: any;
  showQuote: boolean;
  totalPrice: string;
  modulesCompleted: boolean;
  allFloorsUpdated: any;
  allPropertyTypeUpdated: any;

  setFloor: (value: any) => void;
  setProperty: (value: any) => void;
  setPropertyType: (value: any) => void;
  setShowQuote: (value: boolean) => void;
  setAudioMute: (value: boolean) => void;
}

const Topbar: React.FC<Props> = ({ showIntro, audioMute, propertyType, property, floor, showQuote, totalPrice, modulesCompleted, allFloorsUpdated, allPropertyTypeUpdated, setFloor, setProperty, setPropertyType, setAudioMute, setShowQuote}) => {

  const [propertyOptions, setPropertyOptions] = React.useState<any>({});
  const [isMouseGrabbing, setIsMouseGrabbing] = React.useState(false);

  React.useEffect(() => {
    setFloor(Object.keys(allFloorsUpdated)[0]);
  }, [setFloor, allFloorsUpdated]);
  React.useEffect(() => {
    setPropertyType(allPropertyTypeUpdated[0]);
  }, [setPropertyType, allPropertyTypeUpdated]);

  React.useEffect(() => {
    if(floor){
      const options = allFloorsUpdated[floor];
      setPropertyOptions(options);
      const firstOption = Object.keys(options)[0];
      setProperty(options[firstOption]);
    }
  }, [floor, allFloorsUpdated, setProperty]);

  const setLocalProperty = (value: string) => {
    if(!propertyOptions)
      return;
    const property = propertyOptions[value];
    if(!property)
      return;
    setProperty(property);
  };


  const refTopBar = React.useRef<HTMLDivElement>(null);
  const isDown = React.useRef(false);
  const startX = React.useRef(0);
  const scrollLeft = React.useRef(0);

  const onMouseDown = (e: React.MouseEvent) => {
    if (!refTopBar.current) return;
    isDown.current = true;
    setIsMouseGrabbing(true);
    startX.current = e.pageX - refTopBar.current.offsetLeft;
    scrollLeft.current = refTopBar.current.scrollLeft;
  };

  const onMouseLeave = () => {
    isDown.current = false;
    setIsMouseGrabbing(false);
  };

  const onMouseUp = () => {
    isDown.current = false;
    setIsMouseGrabbing(false);
  };

  const onMouseMove = (e: React.MouseEvent) => {
    if (!isDown.current || !refTopBar.current) return;
    e.preventDefault();
    const x = e.pageX - refTopBar.current.offsetLeft;
    const walk = (x - startX.current) * 1;
    refTopBar.current.scrollLeft = scrollLeft.current - walk;
  };


  return (
    <div ref={refTopBar} className={`tour-full-topbar ${showIntro === true ? 'hide':''}`} style={{cursor: isMouseGrabbing ? "grabbing" : "unset"}} onMouseDown={onMouseDown} onMouseLeave={onMouseLeave} onMouseUp={onMouseUp}onMouseMove={onMouseMove}>

      <div className={`tour-topbar-info-container`}>

        <div className={`tour-topbar-info-container-logos`}>
          <img className={`tour-topbar-info-logo`} src={Logo_Constructora} draggable={false} alt=''/>
          <img className={`tour-topbar-info-logo`} src={Logo_Proyecto} draggable={false} alt=''/>
        </div>

        <div className={`tour-topbar-info-border`}/>

        
        <div className={`tour-topbar-info-container-config`}>

          {/* SELECCION TIPO APTO */}
          <div className={`tour-topbar-info-text-block`}>
            <div className={`tour-topbar-info-text-style1`}>TIPO DE APARTAMENTO</div>
          </div>

          {
            allPropertyTypeUpdated.map((property_type: any, index: number) => (
              <div className={`tour-topbar-info-property-type ${propertyType.id === property_type.id ? 'selected':''}`} onClick={()=>setPropertyType(property_type)}>
                <div className={`tour-topbar-info-property-type-text ${propertyType.id === property_type.id ? 'selected':''}`}>{property_type.name}</div>
              </div>
            ))
          }

          <div className={`tour-topbar-info-space2`}/>

          <div className={`tour-topbar-info-text-block`}>
            <div className={`tour-topbar-info-text-style1`}>SELECCIONAR PISO</div>
          </div>
          <div className={`tour-topbar-info-space1`}/>
          <select className={`tour-topbar-info-floor-selection`} onChange={(e: any) => setFloor(e.target.value)}>
            {
              Object.keys(allFloorsUpdated).map((floor_key: string, index: number) => (
                <option key={floor_key} value={floor_key}>{floor_key}</option>
              ))
            }
          </select>

          <div className={`tour-topbar-info-space4`}/>
          <div className={`tour-topbar-info-text-block`}>
            <div className={`tour-topbar-info-text-style1`}>SELECCIONAR</div>
            <div className={`tour-topbar-info-text-style1`}>APARTAMENTO</div>
          </div>
          <div className={`tour-topbar-info-space1`}/>
          <select className={`tour-topbar-info-floor-selection`} onChange={(e: any) => setLocalProperty(e.target.value)}>
            {
              Object.keys(propertyOptions).map((property_key: any, index: number) => (
                <option key={property_key} value={property_key}>{property_key}</option>
              ))
            }
          </select>
        </div>  
      </div>

      <div className={`tour-topbar-quote-container`}>
        <div className={`tour-topbar-quote-text-block`}>
          <div className={`tour-topbar-info-text-style4`}>Este apartamento está costando</div>
          <div className={`tour-topbar-info-text-style5`}>{totalPrice}</div>
        </div>
        <div className={`tour-topbar-info-space3`}/>
        <div className={`tour-topbar-quote-button ${modulesCompleted ? '':'disabled'}`} onClick={()=>{if(modulesCompleted){setShowQuote(true)}}}>
          <div className={`tour-topbar-quote-button-text ${modulesCompleted ? 'enabled':'disabled'}`}>Ver cotización</div>
        </div>

      </div>
    </div>
  );
};

export default Topbar;
